import { graphql } from "relay-runtime"

export const chMedicationSearchQuery = graphql`
  query useChMedicationSearchQuery(
    $searchTerm: String!
    $includeTemplates: Boolean!
    $patientId: ID!
    $appointmentId: ID
  ) {
    ch_medicationSearch(
      searchTerm: $searchTerm
      includeTemplates: $includeTemplates
      patientId: $patientId
      appointmentId: $appointmentId
      top: 100
    ) {
      results {
        id
        itemId
        pharmacode
        medicationType
        name
        searchScore
        category
        highlights {
          key
          value
        }
        dispensingCategory
        packageSizeDescription
        refundCategory
        mainSubstance
        formattedPrice
        therapyDurationDays
      }
    }
  }
`
